import * as S from "./styles";
import { useLoginFormContext } from "@/main/hooks/loginHook";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import Button from "@/main/components/shared/button/button";
import ArrowForward from "@mui/icons-material/ArrowForward";
import { getTranslateByKey } from "@/main/services/utils";
import { KeyValue } from "@/main/models/common";

interface ILoginUserLoggedProps {
	translatesLocal: KeyValue[];
}
function LoginUserLogged({ translatesLocal }: ILoginUserLoggedProps) {
	const { updateHasUserLogged, submitInProgress, onSubmitLoginForm, methods } = useLoginFormContext();
	const formValues = methods.getValues();
	const { username } = formValues;

	const messageLogged = getTranslateByKey("information.userhaveLogged", false, translatesLocal).replace(
		"{0}",
		username,
	);

	return (
		<S.Container>
			<p>{messageLogged}</p>
			<p>{getTranslateByKey("information.logoutInfo", false, translatesLocal)}</p>
			<p>{getTranslateByKey("information.doYouWhantContinue", false, translatesLocal)}</p>

			<S.ContainerButtons>
				<S.ContainerButtons>
					<SecondaryButton
						type="button"
						onClick={() => updateHasUserLogged(false)}
						id="id-login-button-cancel"
						style={{ padding: "0.4rem 1rem", fontSize: "0.8rem", gap: "1rem" }}
					>
						{getTranslateByKey("information.cancel", false, translatesLocal)}
					</SecondaryButton>
					<Button
						type="button"
						isLoading={submitInProgress}
						onClick={() =>
							onSubmitLoginForm({
								...formValues,
								logoutAllDevices: true,
							})
						}
						id="id-login-button-login"
						style={{ padding: "0.4rem 1rem", fontSize: "0.8rem", gap: "1rem" }}
					>
						{getTranslateByKey("information.login", false, translatesLocal)}
						{!submitInProgress && <ArrowForward fontSize="small" />}
					</Button>
				</S.ContainerButtons>
			</S.ContainerButtons>
		</S.Container>
	);
}

export default LoginUserLogged;
